<template>
  <div class="gb-table">
    <div class="gb-table-main" ref="tableView">
      <el-table
        ref="multipleTable"
        height="100%"
        :row-class-name="tableRowClassName"
        :cell-class-name="tableCellClassName"
        :data="tableData"
        @row-click="rowClick"
        @cell-click="cellClick"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="index"
          align="center"
          label="序号"
          fixed="left"
          :key="Math.random()"
          width="50"
        >
          <template slot-scope="scope">
            <span v-if="!!pageSize">{{
              (currentPage - 1) * pageSize + scope.$index + 1
            }}</span>
            <span v-else>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="selection" type="selection" align="center">
        </el-table-column>
        <el-table-column
          v-for="{ prop, label, width, obj } in tableProp"
          :key="prop"
          :width="width"
          :prop="prop"
          align="center"
          :label="label"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="obj" class="omitText">
              <span v-if="prop === 'data.args.updatedAt'">{{
                scope.row | filterObj(prop) | filterDate
              }}</span>
              <span v-else-if="prop === 'data.args.size'">{{
                scope.row | filterObj(prop) | renderSize
              }}</span>
              <span v-else>{{ scope.row | filterObj(prop) }}</span>
            </div>

            <div
              class="omitText"
              v-else-if="
                prop === 'updatedAt' ||
                prop === 'updated_at' ||
                prop === 'createdAt' ||
                prop === 'created_at' ||
                prop === 'pay_time' ||
                prop === 'end_date' ||
                prop === 'latestLoginTime' ||
                prop === 'latestLogoutTime'
              "
            >
              <span v-if="scope.row[prop]">{{
                scope.row[prop] | filterDate
              }}</span>
              <span v-else>-</span>
            </div>
            <div class="omitText" v-else-if="prop === 'fee_type'">
              <span v-if="scope.row[prop] !== null">{{
                scope.row[prop] | filterFeeTypes
              }}</span>
              <span v-else>-</span>
            </div>
            <div class="omitText" v-else-if="prop === 'order_total'">
              <el-popover
                v-if="scope.row['books'] !== null && scope.row['books'].length"
                trigger="hover"
              >
                <div>
                  <div
                    class="table-books-orders-item"
                    v-for="item of scope.row['books']"
                    :key="item.id"
                  >
                    <p
                      class="table-books-orders-model omitText"
                      :title="item.name"
                    >
                      {{ item.name }}
                    </p>
                    <p class="table-books-orders-mac">{{ item.price }}</p>
                  </div>
                </div>
                <span slot="reference" class="table-books-orders-content">{{
                  scope.row["total"]
                }}</span>
              </el-popover>

              <span v-else>-</span>
            </div>
            <div class="omitText" v-else-if="prop === 'orders_status'">
              <span v-if="scope.row['status'] !== null">{{
                scope.row["status"] | filterOrdersStatus
              }}</span>
              <span v-else>-</span>
            </div>
            <div class="omitText" v-else-if="prop === 'public'">
              <span v-if="scope.row.public === 0">未发布</span>
              <span v-if="scope.row.public === 1" class="successText"
                >已发布</span
              >
            </div>
            <div class="omitText" v-else-if="prop === 'publicFeed'">
              <span v-if="scope.row[prop] === 0">否</span>
              <span v-if="scope.row[prop] === 1" class="successText">是</span>
            </div>
            <div class="omitText" v-else-if="prop === 'actionType'">
              <span>{{ scope.row["action"] | filterActionType }}</span>
            </div>
            <div class="omitText" v-else-if="prop === 'configStatus'">
              <span v-if="scope.row[prop] === 0">已禁用</span>
              <span v-if="scope.row[prop] === 1" class="successText"
                >已启用</span
              >
            </div>
            <div class="omitText" v-else-if="prop === 'usable'">
              <span v-if="!scope.row[prop]">已禁用</span>
              <span v-if="scope.row[prop]" class="successText">已启用</span>
            </div>
            <div class="omitText" v-else-if="prop === 'macs'">
              <span v-for="(item, index) in scope.row[prop]" :key="index">
                {{ item }}
                <i v-if="index !== scope.row[prop].length - 1">、</i>
              </span>
            </div>
            <span class="omitText" v-else>{{ scope.row[prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="handleBtn.length"
          :width="handleWidth"
          :label="$t('commonMsg.manage')"
          prop="handle"
          align="center"
        >
          <template #default="scope">
            <div class="handle-btn">
              <template
                v-for="{ icon, type, title, style, showKey } in handleBtn"
              >
                <span
                  v-if="!showKey || scope.row[showKey]"
                  :key="type"
                  :title="title"
                  @click.stop="tableHandle(type, scope.row)"
                >
                  <img v-if="icon" :src="icon" alt="" />
                  <span :class="style">{{ title }}</span>
                </span>
              </template>
            </div>
            <!-- <div v-else>
              <el-popover placement="right" trigger="click">
                <div class="table-popover-handle-btn">
                  <template
                    v-for="{ icon, type, title, style, showKey } in handleBtn"
                  >
                    <span
                      v-if="!showKey || scope.row[showKey]"
                      :key="type"
                      :title="title"
                      @click.stop="tableHandle(type, scope.row)"
                    >
                      <img v-if="icon" :src="icon" alt="" />
                      <span :class="style">{{ title }}</span>
                    </span>
                  </template>
                </div>
                <el-button
                  type="primary"
                  class="el-icon-more"
                  slot="reference"
                ></el-button>
              </el-popover>
            </div> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <slot name="pagination"></slot>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
    },
    tableProp: {
      type: Array,
    },
    handleBtn: {
      type: Array,
      default: () => [],
    },
    handleWidth: {
      type: String,
    },
    selection: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: Number,
  },
  data() {
    return {};
  },
  filters: {
    filterObj(obj, value) {
      let arr = value.split(".");
      let val = {};
      for (let item of arr) {
        if (!Object.keys(val).length) {
          if (!obj[item]) {
            val = "-";
            break;
          } else {
            val = obj[item];
          }
        } else {
          if (!val[item]) {
            val = "-";
            break;
          } else {
            val = val[item];
          }
        }
      }
      return val;
    },
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {},
    tableCellClassName({ row, column, rowIndex, columnIndex }) {},
    tableHandle(type, data) {
      let obj = {
        type,
        data,
      };
      this.$emit("tableHandle", obj);
    },

    handleSelectionChange(data) {
      for (let item of data) {
        item.check = true;
      }
      this.$emit("tableSelectionChange", data);
    },
    rowClick(data) {},
    cellClick(data) {},
    toggleSelection() {
      for (let item of this.tableData) {
        if (item.check) {
          this.$refs.multipleTable.toggleRowSelection(item);
        }
      }
    },
  },
  mounted() {
    this.toggleSelection();
  },
};
</script>

<style lang="scss">
.gb-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff;
  .tableView-noData {
    height: 100% !important;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 220px;
    > .table-empty-msg {
      margin-top: 15px;
      color: #595959;
    }
  }
  .gb-table-main {
    flex: 1;
    width: 100%;
    height: calc(100% - 40px);
    overflow: hidden;
    .list-cover {
      display: flex;
      > img {
        margin-right: 5px;
      }
    }
    .handle-btn {
      display: flex;
      justify-content: center;
      > span {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
    }
  }
  .table-books-orders-content {
    cursor: pointer;
    color: $globalBGColor;
    text-decoration: underline;
  }
}
.table-books-orders-item {
  display: flex;
  align-items: center;
  padding: 5px 0;
  border-bottom: 1px solid #ccc;
  .table-books-orders-model {
    width: 120px;
    color: $globalBGColor;
    font-weight: 500;
    margin-right: 5px;
  }
}
</style>
